import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0196f3d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row securities_basic w-100 m-0" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Liability Balance ", -1))
const _hoisted_6 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_7 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Total Amount Of Acquisition ", -1))
const _hoisted_9 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_10 = {
  class: "col-md-3 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " Acquisition Return ", -1))
const _hoisted_12 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_13 = {
  class: "col-md-1 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " ROI ", -1))
const _hoisted_15 = { class: "m-0 p-0 myinv_label_semi_white" }
const _hoisted_16 = {
  class: "col-md-2 p-0",
  style: {"border":"1px solid #ececec87"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-0 p-0 myinv_label_main" }, " IRR ", -1))
const _hoisted_18 = { class: "m-0 p-0 myinv_label_semi_white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.liability_balance!=='undefined' ? _ctx.basic.liability_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.total_acquisition!=='undefined' ? _ctx.basic.total_acquisition.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.basic.currency_symbol) + " " + _toDisplayString(typeof _ctx.basic.acquisition_return!=='undefined' ? _ctx.basic.acquisition_return.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2}) : 0), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, _toDisplayString(typeof _ctx.basic.roi!=='undefined' ? _ctx.basic.roi: 0), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("p", _hoisted_18, _toDisplayString(typeof _ctx.basic.irr!=='undefined' ? _ctx.basic.irr: 0), 1)
        ])
      ])
    ])
  ]))
}